import { gql } from '@apollo/client';

import {
  codeValueFragment,
  gpsLocationFragment,
  listLocationFragment,
  makeLocationFragment,
} from './commonFragments';

export const DELETE_QUOTE_MUTATION = gql`
  mutation DeleteQuoteMutation($referenceNo: String!) {
    deleteQuote(referenceNo: $referenceNo)
  }
`;

const locationFragment = makeLocationFragment({
  fullState: true,
  otherFields: 'airportDistance, timezone, location {lat, lng}, localMileage',
});

export const QUOTE_DETAIL_QUERY = gql`
  query CustomerQuoteDetailQuery($referenceNo: String!, $prepareConversion: Boolean) {
    getCustomerQuote(referenceNo: $referenceNo, prepareConversion: $prepareConversion){   
      referenceNo
      metadata {
        qolAccount {
          number
          name
        }
      }
      commodity
      serviceType ${codeValueFragment}
      origin ${locationFragment}      
      destination ${locationFragment}
      deliveryDateTime {
        scheduled
        isAsap
      }
      pickupDateTime {
        scheduled
        isNow
      }
      createdDateTime
      expiryDateTime
      dangerousGoods
      unNumber {
        code
        text
      }
      exceptedQty
      packages {
        packagingType {
          code
          text
        }
        packageSource {
          code 
          text
        }
        actualWeight
        billedWeight
        dimensionalWeight
        length
        width
        height
      }
      pieces
      weight
      quoteTotal
      unitSystem
      amounts {
        value
        desc
      }
      flights {
        airline
        flightNumber
        originAirportCode
        destinationAirportCode
        departure {
          estimated
        }
        arrival {
          estimated
        }
        lockout {
          estimated
        }
        originAirportLocation ${gpsLocationFragment}
        destinationAirportLocation ${gpsLocationFragment}
      }
    }
  }
`;

export const QUOTES_QUERY = gql`
  query CustomerQuotesQuery($pageIndex: Int, $pageSize: Int, $filter: QuoteFilter, $sort: Sort) {
    customerQuotes(pageIndex: $pageIndex, pageSize: $pageSize, filter: $filter, sort: $sort) {
      pageIndex
      pageSize
      total
      data {
        metadata {
          qolAccount {
            number
            name
          }
        }
        quoteNumber
        referenceNo
        badge
        origin ${listLocationFragment}
        destination ${listLocationFragment}
        quoteStatus
        pickupDateTime {
          scheduled
        }
        deliveryDateTime {
          scheduled
        }
        expiryDateTime
        bookedDateTime
        shippersReferences
      }
    }
  }
`;

export const GENERATE_QUOTE_ROUTINGS_MUTATION = gql`
  mutation GenerateQuoteRoutings($input: QuoteInput!) {
    generateQuoteRoutings(input: $input) {
      referenceNo
      serviceType ${codeValueFragment}
      commodity
      pickupDateTime {
        scheduled
      }
      deliveryDateTime {
        scheduled
      }
      pieces
      weight
      dangerousGoods
      exceptedQty
      packages {
        actualWeight
        billedWeight
        dimensionalWeight
      }
    }
  }
`;

export const QUOTE_ROUTINGS_QUERY = gql`
  query QuoteRoutingsQuery($referenceNo: String) {
    getQuoteRoutings(referenceNo: $referenceNo) {
      referenceNo
      quoteNumber
      metadata {
        qolAccount {
          number
          name
        }
      }
      commodity
      serviceType ${codeValueFragment}
      origin ${locationFragment}      
      destination ${locationFragment}
      deliveryDateTime {
        scheduled
      }
      pickupDateTime {
        scheduled
      }
      createdDateTime
      expiryDateTime
      dangerousGoods
      unNumber {
        code
        text
      }
      exceptedQty
      packages {
        packagingType {
          code
          text
        }
        packageSource {
          code 
          text
        }
        actualWeight
        billedWeight
        dimensionalWeight
        length
        width
        height
      }
      pieces
      weight
      quoteTotal
      unitSystem
      rank
      amounts {
        value
        desc
      }
      flights {
        airline
        flightNumber
        originAirportCode
        originAirportName
        originAirportTimezone
        destinationAirportCode
        destinationAirportName
        destinationAirportTimezone
        departure {
          estimated
        }
        arrival {
          estimated
        }
        originAirportLocation ${gpsLocationFragment}
        destinationAirportLocation ${gpsLocationFragment}
      }
    }
  }
`;

// selectQuoteRouting
export const SELECT_QUOTE_ROUTING_MUTATION = gql`
  mutation SelectQuoteRouting($referenceNo: String, $quoteId: String) {
    selectQuoteRouting(referenceNo: $referenceNo, quoteId: $quoteId) {
      referenceNo
    }
  }
`;
